module.exports = __webpack_public_path__ + "static/img/鹏飞标志.e43755d2.png";